import styled from 'styled-components';

interface DividerProps {
  orientation?: 'horizontal' | 'vertical';
  variant?: 'solid' | 'dashed' | 'dotted';
  color?: string;
  thickness?: string;
  margin?: string;
  length?: string;
  opacity?: number;
}

export const Divider = styled.div<DividerProps>`
  ${props => {
    const isVertical = props.orientation === 'vertical';
    const thickness = props.thickness || '1px';
    const color = props.color || '#e5e7eb';
    const variant = props.variant || 'solid';
    
    if (isVertical) {
      return `
        width: ${thickness};
        height: ${props.length || '100%'};
        border-left: ${thickness} ${variant} ${color};
        margin: ${props.margin || '0 1rem'};
      `;
    } else {
      return `
        height: ${thickness};
        width: ${props.length || '100%'};
        border-top: ${thickness} ${variant} ${color};
        margin: ${props.margin || '1rem 0'};
      `;
    }
  }}
  
  opacity: ${props => props.opacity || 1};
  flex-shrink: 0;
`;

export const TextDivider = styled.div<Omit<DividerProps, 'orientation'>>`
  display: flex;
  align-items: center;
  margin: ${props => props.margin || '1.5rem 0'};
  
  &::before,
  &::after {
    content: '';
    flex: 1;
    height: ${props => props.thickness || '1px'};
    background: ${props => props.color || '#e5e7eb'};
    opacity: ${props => props.opacity || 1};
  }
  
  &::before {
    margin-right: 1rem;
  }
  
  &::after {
    margin-left: 1rem;
  }
`;

export const TextDividerContent = styled.span`
  color: #6b7280;
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
`;

// Specialized divider variants
export const SectionDivider = styled(Divider)`
  margin: 2rem 0;
  opacity: 0.6;
`;

export const CardDivider = styled(Divider)`
  margin: 1rem 0;
  color: #f3f4f6;
`;

export const ListDivider = styled(Divider)`
  margin: 0.5rem 0;
  opacity: 0.3;
`;

export const VerticalDivider = styled(Divider).attrs({ orientation: 'vertical' })`
  margin: 0 0.75rem;
  height: 1.5rem;
`;

export const FormDivider = styled(TextDivider)`
  margin: 2rem 0;
  
  ${TextDividerContent} {
    background: white;
    padding: 0 1rem;
    color: #9ca3af;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.05em;
  }
`;

export const ModalDivider = styled(Divider)`
  margin: 1.5rem -1.5rem;
  width: calc(100% + 3rem);
`;

export const TableDivider = styled(Divider)`
  margin: 0;
  width: 100%;
  opacity: 0.2;
`;